import { createApi } from '@reduxjs/toolkit/query/react';
import { refreshTokenQuery } from './refreshToken';

export const edpApiV1 = createApi({
  reducerPath: 'edpApiV1',
  baseQuery: refreshTokenQuery,
  keepUnusedDataFor: 0,
  endpoints: () => ({}),
  tagTypes: [
    'ui/mobile/widgets',
    'viewer/me',
    'vacations',
    'singleVacation',
    'consultations',
    'singleConsultation',
    'getMessage',
    'references',
    'employees',
    'division',
    'singleReference',
    'employeesSchedule',
    'setDivision',
    'sendToZupCheck',
    'absence',
    'absenceSingle',
    'allowCheckScheduling',

    'substitutions',
    'singleSubstitution',
    'substitutionsDownloanFile',

    'divisions',
    'news',
    'faq_category',
    'faq',
    'rvd',
    'rvd_users',
    'overtime',
    'overtime_users',
    'employees-organization',
    'admins-organization',
    'roles',
    'admins',
    'vacationApplication',
    'vacationApplicationVacation',
    'ads-employees',
    'ads-division',
    'ads-organization',

    'poll',
    'pollResults',
    'pollOrganization',
    'pollDivision',

    'dayoff',
    'dayoffCanceled',
    'settings',
    'subordinatesVacationsSchedules',
    'admins-info',
    'viewer/organizations',
    'org-structure',
    'substitutions-add',
    'vacationApplicationSupervisors',

    'dayoffSupervisor',
    'dayoffDeputy',
    'dayoffActing',

    'dayoffsCanceledSupervisor',
    'dayoffsCanceledDeputy',
    'dayoffsCanceledActing',

    'vacationSupervisor',
    'vacationDeputy',
    'vacationActing',

    'vacationScheduleSupervisor',
    'vacationScheduleDeputy',
    'vacationScheduleActing',

    'absenceSupervisor',
    'absenceDeputy',
    'absenceActing',
    'absenceTimekeeper',
  ],
});
